import { useNavigate } from 'react-router-dom';
import SocialLinks from './SocialLinks';

export default function Footer() {
  const navigate = useNavigate();
  const year = new Date().getFullYear();

  return (
    <footer style={{
      background: '#0F2C4E',
      borderTop: '1px solid rgba(255,255,255,0.08)',
      padding: '48px 32px 28px',
      marginTop: 0,
    }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>

        {/* Logo and tagline — centered */}
        <div style={{ marginBottom: 40, textAlign: 'center' }}>
          <div style={{ fontFamily: "'DM Serif Display', serif", fontSize: 28, color: '#fff', marginBottom: 8 }}>
            Renter<span style={{ color: '#C9972A' }}>Rep</span>
          </div>
          <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)', lineHeight: 1.6 }}>
            Where Reputation is Key
          </div>
          <div style={{ marginTop: 18 }}>
            <SocialLinks
              size={34}
              color="#fff"
              background="rgba(255,255,255,0.08)"
              hoverBg="#C9972A"
            />
          </div>
        </div>

        {/* Links grid — headers centered, items left-aligned within centered columns */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 40, marginBottom: 40 }}>
          {[
            { align: 'flex-start', textAlign: 'left', paddingLeft: 24,
              title: 'Platform',
              links: [
                { label: 'Search Managers', action: () => navigate('/search?q=Managers') },
                { label: 'Search Tenants', action: () => navigate('/search?q=Tenants') },
                { label: 'Post a Review', action: () => navigate('/signup') },
                { label: 'Sign Up', action: () => navigate('/signup') },
                { label: 'Log In', action: () => navigate('/login') },
              ]
            },
            { align: 'center', textAlign: 'center',
              title: 'Company',
              links: [
                { label: 'About RenterRep', action: () => navigate('/about') },
                { label: 'How It Works', action: () => navigate('/') },
                { label: 'Pricing', action: () => navigate('/pricing') },
                { label: 'FAQ', action: () => navigate('/pricing#faq') },
              ]
            },
            { align: 'flex-end', textAlign: 'left', paddingRight: 24,
              title: 'Support',
              links: [
                { label: 'Contact Us', href: 'mailto:support@renterrep.com' },
                { label: 'Report a Review', href: 'mailto:support@renterrep.com?subject=Report a Review' },
                { label: 'Remove a Review', href: 'mailto:support@renterrep.com?subject=Review Removal Request' },
                { label: 'Legal & Privacy', href: 'mailto:support@renterrep.com?subject=Legal Inquiry' },
                { label: 'Press', href: 'mailto:support@renterrep.com?subject=Press Inquiry' },
              ]
            }
          ].map((col, i) => (
            <div key={i} style={{ display: 'flex', flexDirection: 'column', alignItems: col.align, paddingLeft: col.paddingLeft || 0, paddingRight: col.paddingRight || 0 }}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.4)', textTransform: 'uppercase', letterSpacing: 1.2, marginBottom: 16, textAlign: 'left' }}>
                  {col.title}
                </div>
                {col.links.map((l, j) => (
                  <div key={j} style={{ marginBottom: 10 }}>
                    {l.href ? (
                      <a href={l.href} style={{ color: 'rgba(255,255,255,0.65)', fontSize: 13, textDecoration: 'none', lineHeight: 1.6 }}>
                        {l.label}
                      </a>
                    ) : (
                      <button onClick={l.action} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.65)', fontSize: 13, cursor: 'pointer', padding: 0, lineHeight: 1.6, textAlign: 'left' }}>
                        {l.label}
                      </button>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: 24, textAlign: 'center' }}>
          <div style={{ display: 'flex', justifyContent: 'center', gap: 24, marginBottom: 14, flexWrap: 'wrap' }}>
            {[
              { label: 'Terms of Service', href: 'mailto:support@renterrep.com?subject=Terms of Service' },
              { label: 'Privacy Policy', href: 'mailto:support@renterrep.com?subject=Privacy Policy' },
              { label: 'Fair Housing', href: 'mailto:support@renterrep.com?subject=Fair Housing' },
            ].map((l, i) => (
              <a key={i} href={l.href} style={{ fontSize: 12, color: 'rgba(255,255,255,0.35)', textDecoration: 'none' }}>
                {l.label}
              </a>
            ))}
          </div>
          <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.35)', marginBottom: 10 }}>
            © {year} RenterRep, LLC. All rights reserved.
          </div>
          <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.25)', lineHeight: 1.7, maxWidth: 600, margin: '0 auto' }}>
            RenterRep does not write, endorse, or represent any reviews on this platform. All reviews are the sole opinion of individual users. RenterRep is not liable for any user-submitted content.
          </div>
        </div>
      </div>
    </footer>
  );
}
